import React from 'react';
import Footer from '../components/Footer';
import FAQItem from '../components/FAQItem';
import { FiFlag, FiHeart, FiLink, FiMessageCircle, FiSearch, FiShare2, FiUser, FiUsers } from 'react-icons/fi';
import Header from '../components/Header';
import SEO from '../components/SEO';
import faqItems from '../data/faqs.json';

const faqIcons = [FiHeart, FiFlag, FiSearch, FiShare2, FiLink, FiUser, FiMessageCircle, FiUsers];

const faqSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://lrnaicare.net/#organization',
      name: 'lrnaicare.net',
      url: 'https://lrnaicare.net/',
      logo: {
        '@type': 'ImageObject',
        '@id': 'https://lrnaicare.net/#logo',
        url: 'https://lrnaicare.net/logo.webp',
        contentUrl: 'https://lrnaicare.net/logo.webp',
      },
    },
    {
      '@type': 'WebSite',
      '@id': 'https://lrnaicare.net/#website',
      url: 'https://lrnaicare.net/',
      name: 'lrnaicare.net',
      publisher: {
        '@id': 'https://lrnaicare.net/#organization',
      },
    },
    {
      '@type': 'FAQPage',
      '@id': 'https://lrnaicare.net/faq/#webpage',
      name: 'Frequently Asked Questions | lrnaicare.net',
      url: 'https://lrnaicare.net/faq/',
      isPartOf: {
        '@id': 'https://lrnaicare.net/#website',
      },
      publisher: {
        '@id': 'https://lrnaicare.net/#organization',
      },
      mainEntity: faqItems.map((item) => ({
        '@type': 'Question',
        name: item.title,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.content,
        },
      })),
    },
  ],
};

export default function FAQPage() {
  return (
    <div className="page-shell min-h-screen">
      <SEO
        title="Frequently Asked Questions | Learnaicare"
        description="Find answers to common questions about subscriptions, billing charges, cancellations, account access, and customer support services."
        canonical="https://lrnaicare.net/faq/"
        ogUrl="https://lrnaicare.net/faq/"
        schema={faqSchema}
      />
      <Header />

      <section className="relative w-full overflow-hidden mt-0">
        <div className="relative w-full px-0 py-0">
          <div className="w-full mx-auto max-w-full rounded-[1rem] border-t border-white/60 bg-white/90 py-8 sm:py-10 shadow-[0_12px_36px_-20px_rgba(7,26,49,0.12)] backdrop-blur-sm">
            <div className="max-w-4xl mx-auto px-6 sm:px-8">
              <h1 className="mt-4 text-center text-3xl font-bold leading-tight text-[#2f4f42] sm:text-4xl">
                Frequently asked questions
              </h1>

              <p className="mt-3 text-center text-sm leading-7 text-[#5e675f] max-w-2xl mx-auto">
                Everything you need to understand your subscription management, cancellation process, and support access.
              </p>
            </div>
          </div>
        </div>
      </section>

      <main className="px-4 py-8 sm:px-6 lg:px-8 lg:py-10 mt-2 sm:mt-3 lg:mt-4">
        <div className="mx-auto max-w-4xl px-2 sm:px-0">
          <section>
            <div className="space-y-6">
              {faqItems.map((item, index) => {
                const Icon = faqIcons[index] ?? FiHeart;

                return (
                  <FAQItem key={item.title} title={item.title} icon={<Icon />}>
                    {item.content}
                  </FAQItem>
                );
              })}
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}

